import "preact/debug"

import { render } from "preact"
import "./analytics"
import { App } from "./App"
import "./fonts.css"
import "./reset.css"
import { TestResults } from "./TestResults"

render(
  <>
    <TestResults />
    <App />
  </>,
  document.getElementById("app")!,
)
